import { render, staticRenderFns } from "./AssociatedProjectsTab.vue?vue&type=template&id=a887efcc&scoped=true"
import script from "./AssociatedProjectsTab.vue?vue&type=script&lang=js"
export * from "./AssociatedProjectsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a887efcc",
  null
  
)

export default component.exports